import { render } from "./BuildBoardsPage.vue?vue&type=template&id=1a6fe7d8&scoped=true"
import script from "./BuildBoardsPage.vue?vue&type=script&lang=js"
export * from "./BuildBoardsPage.vue?vue&type=script&lang=js"

import "./BuildBoardsPage.vue?vue&type=style&index=0&id=1a6fe7d8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a6fe7d8"]])

export default __exports__